module.exports = __webpack_public_path__ + "static/media/059-location.2b29883f.svg";